import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class PermissionService {
  private permissions: string[] = [];

  constructor() {
    this.loadPermissionsFromLocalStorage();
  }

  private loadPermissionsFromLocalStorage(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsed = JSON.parse(userData);
        this.permissions = parsed?.permissions || [];
      } catch (error) {
        console.error('Failed to parse user data:', error);
        this.permissions = [];
      }
    }
  }

  public hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }

  public getAllPermissions(): string[] {
    return [...this.permissions];
  }
}
